import { TextInput } from '@dreryk/react-components';

import { translationKeys } from '../../../../../translations';
import { CustomPatientGroupsFormController } from '../CustomPatientGroupsForm.types';

const CUSTOM_PATIENT_GROUPS_NAME_FIELD_NAME = 'name';
const CUSTOM_PATIENT_GROUPS_NAME_MAX_LENGTH = 100;

export type CustomPatientGroupsNameFormBeanPart = { [CUSTOM_PATIENT_GROUPS_NAME_FIELD_NAME]: string };

type CustomPatientGroupsNameProps = Pick<CustomPatientGroupsFormController, 'register'>;

export const CustomPatientGroupsName = (props: CustomPatientGroupsNameProps): JSX.Element => {
   return (
      <TextInput
         testId={CUSTOM_PATIENT_GROUPS_NAME_FIELD_NAME}
         label={translationKeys.customGroupName}
         placeholder={translationKeys.fillCustomGroupName}
         controller={props.register(CUSTOM_PATIENT_GROUPS_NAME_FIELD_NAME, {
            required: true,
            maxLength: CUSTOM_PATIENT_GROUPS_NAME_MAX_LENGTH,
         })}
      />
   );
};
